import { TAX_CATEGORIES } from './types';
import { impliedNationality, isIdentityDocType } from './identity';
export function regimeAt(profile, date) {
    const day = (typeof date === 'string' ? date : date.toISOString()).slice(0, 10);
    const inForce = [...profile.tax]
        .filter((rule) => rule.effectiveFrom <= day)
        .sort((a, b) => (a.effectiveFrom < b.effectiveFrom ? 1 : -1));
    return inForce[0] ?? NO_TAX;
}
export const NO_TAX = {
    code: 'none',
    effectiveFrom: '1900-01-01',
    registration: null,
    companyRegistrationLabelKey: null,
    companyRegistrationLabel: null,
    standardRatePct: null,
    serviceDefaultCategory: 'out_of_scope',
    productDefaultCategory: 'out_of_scope',
    qr: null,
    citizenRelief: null,
};
export function isTaxCategory(value) {
    return typeof value === 'string' && TAX_CATEGORIES.includes(value);
}
export const RESIDENT_KINDS = ['citizen', 'non_citizen'];
export function residentKindOf(params) {
    if (!params.branchCountry)
        return 'non_citizen';
    const declared = params.nationality?.trim().toUpperCase() || null;
    const implied = isIdentityDocType(params.idType) ? impliedNationality(params.profile, params.idType) : null;
    return (declared ?? implied) === params.branchCountry ? 'citizen' : 'non_citizen';
}
export function branchRateOn(rows, category, residentKind, day) {
    let found = null;
    for (const row of rows) {
        if (row.taxCategory !== category || row.residentKind !== residentKind || row.effectiveFrom > day)
            continue;
        if (!found || row.effectiveFrom > found.effectiveFrom)
            found = row;
    }
    return found;
}
export function profileTaxRates(regime) {
    if (regime.standardRatePct === null)
        return [];
    const standard = regime.standardRatePct;
    const citizenStandard = regime.citizenRelief ? 0 : standard;
    return TAX_CATEGORIES.flatMap((taxCategory) => RESIDENT_KINDS.map((residentKind) => ({
        taxCategory,
        residentKind,
        pct: taxCategory !== 'standard' ? 0 : residentKind === 'citizen' ? citizenStandard : standard,
    })));
}
export function lineTaxTreatment(params) {
    const itemPct = Math.max(0, Number(params.item.taxPct ?? 0));
    const relief = params.regime.citizenRelief;
    const reliefApplies = Boolean(relief) && params.side !== 'payer' && params.source === 'service';
    const branchRate = (category) => params.branch && params.source === 'service' ? branchRateOn(params.branch.rates, category, params.side === 'payer' ? 'non_citizen' : params.branch.residentKind, params.branch.day) : null;
    if (params.override) {
        const category = params.override.category;
        const rate = branchRate(category);
        return {
            ratePct: category === 'standard' ? (rate ? rate.pct : itemPct || (params.regime.standardRatePct ?? 0)) : 0,
            category,
            reason: params.override.reason,
        };
    }
    const stored = isTaxCategory(params.item.taxCategory) ? params.item.taxCategory : null;
    const category = stored ?? (itemPct > 0 ? 'standard' : params.source === 'service' ? params.regime.serviceDefaultCategory : params.regime.productDefaultCategory);
    const rate = branchRate(category);
    if (rate) {
        if (relief && reliefApplies && category === 'standard' && params.branch?.residentKind === 'citizen' && rate.pct === 0) {
            return { ratePct: 0, category: relief.category, reason: relief.reason };
        }
        return { ratePct: category === 'standard' ? rate.pct : 0, category, reason: null };
    }
    if (relief && reliefApplies && category === 'standard' && params.patientIdType === relief.idType) {
        return { ratePct: 0, category: relief.category, reason: relief.reason };
    }
    return { ratePct: category === 'standard' ? itemPct : 0, category, reason: null };
}
//# sourceMappingURL=tax.js.map